import styled from 'styled-components';

export const InputExample = styled.span`
  margin-left: 5px;
`;
